import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dashboard p-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col items-center justify-center h-full"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg mt-8" }, " This is where Subscribers can see their teams' emotional progress. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg mb-8" }, "Find out how your employees are feeling.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardList = _resolveComponent("DashboardList")!
  const _component_SubscriptionModal = _resolveComponent("SubscriptionModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.hasSubscription)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_DashboardList)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          (_ctx.isAdmin)
            ? (_openBlock(), _createBlock(_component_SubscriptionModal, { key: 0 }))
            : _createCommentVNode("", true)
        ]))
  ]))
}